import React, { useState } from 'react';
import { format } from 'date-fns';
import { getGuests } from '../../SearchEntryWidget/defaultData';
import { getAnalyticsArrivalDates } from '../../SearchForm/helpers/dates';
import GuestCounter from '../../SearchForm/children/GuestCounter';
const getNumberOrDefault = ({ stateValue, defaultNumber, }) => {
    if (stateValue === '') {
        return defaultNumber;
    }
    return Number(stateValue !== null && stateValue !== void 0 ? stateValue : defaultNumber);
};
export const getDefaultStateFromQuery = ({ adults, tots, dogs, children }) => (state) => ({
    adults: getNumberOrDefault({ stateValue: state === null || state === void 0 ? void 0 : state.adults, defaultNumber: adults }),
    children: getNumberOrDefault({ stateValue: state === null || state === void 0 ? void 0 : state.children, defaultNumber: children }),
    tots: getNumberOrDefault({ stateValue: state === null || state === void 0 ? void 0 : state.tots, defaultNumber: tots }),
    dogs: getNumberOrDefault({ stateValue: state === null || state === void 0 ? void 0 : state.dogs, defaultNumber: dogs }),
    accessibleVans: String(state === null || state === void 0 ? void 0 : state.accessibleVans).toLowerCase() === 'true',
});
export const accessibleAnalyticsPayload = ({ parkCodes, dates = [], duration, adults, children, infants, dogs, }) => {
    const [startDate, endDate] = dates;
    const formatter = (date) => format(date, 'yyyy-MM-dd');
    const arrivalDates = getAnalyticsArrivalDates(startDate, endDate).map(formatter);
    return {
        event: 'visitor interaction',
        interactionName: 'link click',
        linkType: 'accessible holidays',
        linkText: 'discover and book wheelchair accessible accommodation',
        linkUrl: 'https://www.haven.com/holidays/accessible',
        productType: 'self catering',
        parkCode: (parkCodes === null || parkCodes === void 0 ? void 0 : parkCodes.length) ? parkCodes.join('|') : null,
        arrivalDate: arrivalDates.length ? arrivalDates.join('|') : null,
        numArrivalDates: (arrivalDates === null || arrivalDates === void 0 ? void 0 : arrivalDates.length) || null,
        duration: duration ? duration.join('|') : null,
        adults,
        children,
        infants,
        dogs,
        numGuests: adults + children + infants,
        partyConfig: `${adults} adults|${children} children|${infants} infants|${dogs} dogs`,
    };
};
export const GuestSelector = ({ guestCounterId, onSelect, defaultGuests = {
    adults: 2,
    children: 2,
    tots: 0,
    dogs: 0,
}, queryState, dogsAllowed, dogsAllowedText, handleGTMFilterChange, dogsSelector = true, maximumPartyCount = 8, accessibleCaravan, accessibleAllowed, onAccessibleVanChange, onAccessibleLinkPayload, analytics, allowZeroValues = false, }) => {
    const defaultStateFromQuery = getDefaultStateFromQuery(defaultGuests)(queryState);
    const [localState, setLocalState] = useState(defaultStateFromQuery);
    const DefaultDataWithZero = [
        {
            type: 'adults',
            label: 'Adults',
            defaultValue: 2,
            maxValue: 8,
            minValue: 0,
            description: '16+ yrs (lead must be over 18)',
        },
        {
            type: 'children',
            label: 'Children',
            defaultValue: 2,
            minValue: 0,
            maxValue: 8,
            description: '5-15 yrs',
        },
        {
            type: 'tots',
            label: 'Infants',
            defaultValue: 0,
            minValue: 0,
            maxValue: 7,
            description: '0-4 yrs',
        },
        {
            type: 'dogs',
            label: 'Dogs',
            defaultValue: 0,
            minValue: 0,
            maxValue: 2,
            description: '',
        },
    ];
    const innerGetGuests = () => {
        const maximumPartyReached = +((queryState === null || queryState === void 0 ? void 0 : queryState.adults) || 0) + +((queryState === null || queryState === void 0 ? void 0 : queryState.children) || 0) + +((queryState === null || queryState === void 0 ? void 0 : queryState.tots) || 0) >=
            maximumPartyCount;
        const guests = allowZeroValues ? DefaultDataWithZero : getGuests();
        return guests.reduce((arr, guest) => {
            return [
                ...arr,
                ...(maximumPartyReached && (guest === null || guest === void 0 ? void 0 : guest.type) !== 'dogs'
                    ? [
                        Object.assign(Object.assign({}, guest), { maxValue: +localState[guest === null || guest === void 0 ? void 0 : guest.type] }),
                    ]
                    : [guest]),
            ];
        }, []);
    };
    const innerOnChange = (type, value) => {
        setLocalState(Object.assign(Object.assign({}, localState), { [type]: value }));
        onSelect(type)(value);
        handleGTMFilterChange('number of guests', `${+((localState === null || localState === void 0 ? void 0 : localState.adults) || 0)} adults|` +
            `${+((localState === null || localState === void 0 ? void 0 : localState.children) || 0)} children|` +
            `${+((localState === null || localState === void 0 ? void 0 : localState.tots) || 0)} infants|` +
            `${+((localState === null || localState === void 0 ? void 0 : localState.dogs) || 0)} dogs`);
    };
    const innerOnAccessibleVanChange = () => {
        setLocalState(Object.assign(Object.assign({}, localState), { accessibleVans: !localState.accessibleVans }));
        onAccessibleVanChange === null || onAccessibleVanChange === void 0 ? void 0 : onAccessibleVanChange(!localState.accessibleVans);
    };
    return (<div className='bl-haven-guestSelector'>
      <GuestCounter id={guestCounterId || ''} onChange={innerOnChange} types={innerGetGuests()} state={localState} dogsAllowed={dogsAllowed} dogsSelector={dogsSelector} dogsAllowedText={dogsAllowedText} accessibleCaravan={accessibleCaravan} accessibleAllowed={accessibleAllowed} onAccessibleVanChange={innerOnAccessibleVanChange} onAccessibleLinkPayload={onAccessibleLinkPayload} analytics={analytics}/>
    </div>);
};
